import MultiScreenControlPanel from './MultiScreenControlPanel'

export default MultiScreenControlPanel
